import { INDEXED_DB, SQLITE_PLUGIN } from './supportedDbTechnology';

// "PersistentStorage" here is not referring to storage.persist. It just means
// "a database that stores data across page loads", i.e. not fake-indexed-db
export default function dbHasPersistentStorage(db) {
    return [INDEXED_DB, SQLITE_PLUGIN].includes(db?.dbTechnology);
}
